import onelps from '../../api';

export const play = async function(dispatchFn) {
	try {
		const result = await onelps.actions.play();

		return result;
	}
	catch (e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};
